'use strict';

var validUrl = require('valid-url');

module.exports = {
	validatePassword: function validatePassword(password) {
		if (!password || password.length < 8) {
			return 'Please enter a password of at least 8 characters';
		}

		return null;
	},

	validateUrl: function validateUrl(url) {
		if (!url) {
			return null;
		}

		if (!validUrl.isWebUri(url) || url.indexOf('.') === -1) {
			return 'Please enter a valid URL';
		}

		return null;
	}
};


//////////////////
// WEBPACK FOOTER
// ./lib/validations.js
// module id = 175
// module chunks = 5